import { resolvedBreakpoint } from './resolvedBreakpoint';

export const resolveGridWith = (props, windowWidth = 0) => resolvedBreakpoint(props, windowWidth) || 12;